<div class="section-wrapper" id="annual_report">
  <div class="container">
    <h2 class="title">{{ "COMPANY.ANNUAL_REPORT.TITLE" | translate }}</h2>
    <div class="d-flex flex-wrap gap-2">
      <a
        class="financial-report-content"
        href="assets/docs/AnnualReport2024-IJEE-Final Version 3.pdf"
        target="_blank"
      >
        {{ "COMPANY.ANNUAL_REPORT.ANNUAL_REPORT_2024" | translate }}
      </a>
    </div>
  </div>
</div>

<div class="section-wrapper" id="financial_report">
  <div class="container">
    <h2 class="title">{{ "COMPANY.FINANCIAL_REPORT.TITLE" | translate }}</h2>
    <div class="d-flex flex-wrap gap-2">
      <a
        class="financial-report-content"
        href="assets/docs/Report_PT Integrasi Jaringan Ekosistem 31_Mar_2025 signed.pdf"
        target="_blank"
      >
        {{ "COMPANY.FINANCIAL_REPORT.FINANCIAL_REPORT_Q1_2025" | translate }}
      </a>
      <a
        class="financial-report-content"
        href="assets/docs/Final Report PT Integrasi Jaringan Ekosistem 31 Desember 2024 (2).pdf"
        target="_blank"
      >
        {{ "COMPANY.FINANCIAL_REPORT.FINANCIAL_REPORT_Q4_2024" | translate }}
      </a>
      <a
        class="financial-report-content"
        href="assets/docs/PT_Integrasi_Jaringan_Ekosistem-241031_1204_FINAL.pdf"
        target="_blank"
      >
        {{ "COMPANY.FINANCIAL_REPORT.FINANCIAL_REPORT_Q3_2024" | translate }}
      </a>
      <a
        class="financial-report-content"
        href="assets/docs/Financial_Report_PT_IJE_30_Juni_2024.pdf"
        target="_blank"
      >
        {{ "COMPANY.FINANCIAL_REPORT.FINANCIAL_REPORT_Q2_2024" | translate }}
      </a>
      <a
        class="financial-report-content"
        href="assets/docs/Final_Report_PT_Integrasi_Jaringan_Ekosistem_31_Maret_2024.pdf"
        target="_blank"
      >
        {{ "COMPANY.FINANCIAL_REPORT.FINANCIAL_REPORT_Q1_2024" | translate }}
      </a>
    </div>
  </div>
</div>
